import axios from "axios";
import { getSelectedBrandCode } from "./brandContext";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  timeout: 300000, // 5 mins
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add the JWT token to the headers
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("accessToken");

    if (token) {
      // Add token to Authorization header if present
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["X-Brand-Code"] = getSelectedBrandCode();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
